var map = {
	"./gallery-1.jpg": 746,
	"./gallery-2.jpg": 949,
	"./gallery-3.jpg": 984,
	"./gallery-4.jpg": 571,
	"./gallery-5.jpg": 614,
	"./gallery-6.jpg": 209,
	"./gallery-7.jpg": 948,
	"./hero-outdoors.jpg": 608,
	"./welcome-space.jpg": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 626;